import React from "react";
import { Container } from "@mui/material";
import ChatWindow from "src/components/Chat/ChatWindow";

const ChatPage: React.FC = () => {
  return (
    <div className="App">
      <ChatWindow />
    </div>
  );
};

export default ChatPage;
